<template>
  <div class="u-wrap">
    <div class="u-content">
      <div class="card">
        <van-form>
          <div class="xhx">您对本次事件的评价</div>
          <div class="pj">
            <div class="pj-item" v-for="(item, index) in list" :key="index" >
              <img :src="params.pjlb == item.code ? item.icon1 : item.icon" />
              <span :class="[active == index ? 'myd_s' : 'myd']">{{ item.name }}</span>
            </div>
          </div>
          <div class="line"></div>
          <div class="xhx">评价内容</div>
          <div  class="xxnr" >{{params.pjnr}}</div>
        </van-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      model: {
        xfdjId: '',
        pjlb: '',
        pjnr: '',
        phone: '',
      },
      active: -1,
      list: [
        { icon: require('@images/gzfw/bmy.png'), icon1: require('@images/gzfw/bmy_s.png'), name: '不满意', code: '03' },
        { icon: require('@images/gzfw/my.png'), icon1: require('@images/gzfw/my_s.png'), name: '基本满意', code: '02' },
        {
          icon: require('@images/gzfw/fcmy.png'),
          icon1: require('@images/gzfw/fcmy_s.png'),
          name: '满意',
          code: '01',
        },
      ],
      senMsg_type: 1,
      secodes: 60,
      myTimer: null,
      sendTxt: '获取验证码',
      sms: '',
      params: {},
    }
  },
  created() {
    this.params = this.$route.query;
    
  },
  mounted() {},
  methods: {
  },
}
</script>

<style lang="less" scoped>
.u-wrap {
  height: 100vh;
  box-sizing: border-box;
  padding-top: 12px;
  background-image: linear-gradient(180deg, #d2e3ff 0%, #ffffff 30%);
  display: flex;
  flex-direction: column;
}
.u-content-wrap {
  flex: 1;
  display: flex;
}

.card {
  background: #ffffff;
  padding: 0px 0px 16px;
  margin: 0 8px;
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.04);
  border-radius: 5px;
  overflow: hidden;
  height: auto;
  margin-bottom: 12px;
}

.xxnr {
  width: 90%;
  margin: 0 12px;
  height: 380px;
  border-radius: 5px;
  // border: 1px solid #ededed;
  border: none;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  padding: 2px;
  font-size: 16px;
  color: #666666;
  text-indent: 1em;
}

.b-btn {
  width: 100%;
  height: 75px;
  background: #ffffff;
  // box-shadow: 0 -1px 4px #E6E6E680;
  // box-shadow: 0 -2px 7px 0 #e6e6e680;
  display: flex;
  align-items: center;
  padding: 0 22px;
  box-sizing: border-box;
  // border-top: 1px solid #e3e3e3;

  .b-button {
    width: 100%;
    height: 40px;
    background: #2593e1;
    border-radius: 40px;
    border: none;
    color: #fff;
  }

  .b-button[disabled] {
    opacity: 0.48;
  }
}

.xhx {
  width: 100%;
  position: relative;
  color: #1a1a1a;
  padding-left: 16px;
  height: 40px;
  line-height: 40px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  font-size: 16px;
  color: #333333;
}
// .xhx::before {
//   position: absolute;
//   left: 8px;
//   color: #ee0a24;
//   font-size: 14px;
//   content: '*';
// }

.pj {
  display: flex;
  justify-content: space-around;
  padding: 14px 16px;
  .pj-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    img {
      width: 36px;
      height: 36px;
      margin-bottom: 10px;
    }
    .myd {
      font-size: 14px;
      color: #666666;
    }

    .myd_s {
      font-size: 14px;
      color: #ffaf50;
      font-weight: bold;
    }
  }
}

.line {
  margin: 0 12px;
  background: #ebedf0;
  height: 0.5px;
}

.u-wrap /deep/ .van-button--primary {
  background-color: #3f8ffb;
  border: 1px solid #3f8ffb;
}
/deep/ .van-field__label {
  width: 7em;
  color: #333333;
}

/deep/ .van-cell {
  padding: 18px 16px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  font-size: 16px;
  color: #333333;
}

/deep/ .van-cell__value {
  color: #666666;
}
/deep/ .van-field__control {
  color: #666666;
}

.yzm {
  font-family: PingFangSC-Medium;
  font-weight: 500;
  font-size: 16px;
  color: #2593e1;
}

.u-content {
  flex: 1;
  overflow-y: scroll;
}

/deep/ input::placeholder {
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 16px;
  color: #cccccc;
}

textarea::placeholder {
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 16px;
  color: #cccccc;
}
</style>
